import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/socials/facebook.svg'
import _imports_1 from '@/assets/images/socials/linkedin.svg'


const _withScopeId = n => (_pushScopeId("data-v-2e4ff504"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "contact-us" }
const _hoisted_2 = { id: "contact-us-title-container" }
const _hoisted_3 = {
  class: "section-top-text",
  id: "contact-top-text"
}
const _hoisted_4 = {
  class: "section-sub-text",
  id: "contact-sub-text"
}
const _hoisted_5 = { class: "contact-content" }
const _hoisted_6 = { class: "contact-form-container" }
const _hoisted_7 = { id: "contactForm" }
const _hoisted_8 = { for: "name" }
const _hoisted_9 = { for: "message" }
const _hoisted_10 = { id: "submit-btn-content-container" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"envelope-container\" data-v-2e4ff504><div class=\"envelope-top\" data-v-2e4ff504></div><div class=\"envelope-left\" data-v-2e4ff504></div><div class=\"envelope-back\" data-v-2e4ff504><div class=\"envelope-paper\" data-v-2e4ff504></div></div><div class=\"envelope-right\" data-v-2e4ff504></div><div class=\"envelope-bottom\" data-v-2e4ff504></div></div>", 1)
const _hoisted_12 = { class: "contact-socials-container" }
const _hoisted_13 = { class: "section-top-text" }
const _hoisted_14 = { id: "contact-social-icons" }
const _hoisted_15 = { class: "social-card" }
const _hoisted_16 = { class: "social-card-title" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<a class=\"social-card-link\" href=\"https://www.facebook.com/innovatorshubkortenberg\" target=\"_blank\" data-v-2e4ff504><div class=\"social-link-container\" data-v-2e4ff504><p data-v-2e4ff504>innovatorshub</p><div class=\"icon-flip-container\" data-v-2e4ff504><div class=\"icon-flipper\" data-v-2e4ff504><div class=\"icon-front\" data-v-2e4ff504></div><div class=\"icon-back\" data-v-2e4ff504><img class=\"icon-social-img\" src=\"" + _imports_0 + "\" alt=\"Facebook\" data-v-2e4ff504></div></div></div></div></a>", 1)
const _hoisted_18 = { class: "social-card" }
const _hoisted_19 = { class: "social-card-title" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<a class=\"social-card-link\" href=\"https://www.linkedin.com/company/innovatorshub-kortenberg/?viewAsMember=true\" target=\"_blank\" data-v-2e4ff504><div class=\"social-link-container\" data-v-2e4ff504><p data-v-2e4ff504>InnovatorsHub Kortenberg</p><div class=\"icon-flip-container\" data-v-2e4ff504><div class=\"icon-flipper\" data-v-2e4ff504><div class=\"icon-front\" data-v-2e4ff504></div><div class=\"icon-back\" data-v-2e4ff504><img class=\"icon-social-img\" src=\"" + _imports_1 + "\" alt=\"LinkedIn\" data-v-2e4ff504></div></div></div></div></a>", 1)

import {ref} from "vue";
import {getCurrentInstance} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactUs',
  setup(__props) {

const name = ref("");
const message = ref("");
const instance = getCurrentInstance();
const translator = instance?.appContext.config.globalProperties.$translatorUtils;
const sendMail = () => {
  window.location.href =
      `mailto:info@innovatorshub.be?subject=Info Innovatorshub from ${name.value}&body=${encodeURIComponent(message.value)}`;
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(translator).trans("general.contact_us.top_text")), 1),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(translator).trans("general.contact_us.sub_text")), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("form", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(translator).trans("general.contact_us.form.name_label")), 1),
          _withDirectives(_createElementVNode("input", {
            class: "form-input",
            type: "text",
            id: "name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event))
          }, null, 512), [
            [_vModelText, name.value]
          ]),
          _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(translator).trans("general.contact_us.form.message_label")), 1),
          _withDirectives(_createElementVNode("textarea", {
            class: "form-input",
            id: "message",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((message).value = $event))
          }, null, 512), [
            [_vModelText, message.value]
          ]),
          _createElementVNode("button", {
            id: "submit-btn",
            type: "button",
            onClick: sendMail
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", null, _toDisplayString(_unref(translator).trans("general.contact_us.form.send_button")), 1),
              _hoisted_11
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("h2", _hoisted_13, _toDisplayString(_unref(translator).trans("general.contact_us.connect_with_us")), 1),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(translator).trans("general.contact_us.socials.facebook")), 1),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(translator).trans("general.contact_us.socials.linkedin")), 1),
            _hoisted_20
          ])
        ])
      ])
    ])
  ]))
}
}

})